import { navigate as gatsbyNavigate } from 'gatsby'
import { store } from '@redux/store'
import { setShowSearchResults } from '@redux/modules/global'

/*
  This function will be used to decide whether or not to use gatsby navigate to route.
  The reason we cant use gatsby navigate in a prod like environment is because there is a 
  dynamic pdp available but we swap the route to a server side for any routes that contain
  /product/ in the route. The reason we need this code is because product routes can be 
  handle both statically and on server. To remove issues with this duplication we can
  have code decide when to use gatsby's navigation.
*/
export const canClientSideRoute = (locationPath, linkPath) => {
  const fullRoutePath = '/furniture/product/'
  const matchesFullRoutePath = [locationPath, linkPath].find(path => path && path.match(fullRoutePath))
  return !matchesFullRoutePath
}

export const navigate = (slug, replace = false) => {
  if (typeof window === 'undefined') {
    return
  }
  if (store.getState().global.showSearchResults) {
    store.dispatch(setShowSearchResults(false))
  }
  let location = ''
  location = window.location.pathname
  if (canClientSideRoute(location, slug)) {
    gatsbyNavigate(slug, { replace })
  } else if (replace) {
    window.location.replace(slug)
  } else {
    window.location.href = slug
  }
}

export default navigate
